import React from 'react';

const BaseRadioGroup = ({ label, name, options, value, onChange, onBlur, error, touched }) => {
  return (
    <div className="mb-3 d-flex justify-content-start gap-3 align-items-center">
      <div className='d-flex align-items-center justify-content-center'>
      <label className="form-label mt-2">{label}</label>
      <span className="text-danger">*</span>:
      </div>
      <div>
        {options.map((option) => (
          <div className=" form-check form-check-inline" key={option.value}>
            <input
              className={`form-check-input ${error && touched ? "is-invalid" : ""}`}
              type="radio"
              id={`${name}-${option.value}`}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              onBlur={onBlur}
            />
            <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {error && touched && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default BaseRadioGroup;